import logo from './logo.svg';
import './App.css';
import InstituteOnBoarding from './components/InstituteOnBoarding';
import InstituteDashboard from './components/instituteDashboard';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
        <Routes>  
          <Route path="/" element={<InstituteDashboard />} />
          {/* <Route path="/" element={<InstituteOnBoarding />} /> */}
          <Route path="/register" element={<InstituteOnBoarding />} />
        </Routes>
      </Router>
  );
}

export default App;
